// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"street-road"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M3 3H21V21H3V3Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M3 3H21V21H3V3Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M7 12L9.08333 10.75M9.08333 10.75L17 6M9.08333 10.75L7 7M17 12L14.9167 13.25M14.9167 13.25L7 18M14.9167 13.25L17 17","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const StreetRoadIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'street-road',
    ref,
    icon: element,
  },
));

StreetRoadIcon.displayName = 'StreetRoadIcon';

export default StreetRoadIcon;
